export const TRANSFER_STEPS = {
	EVENT: 1,
	ITEMS: 2,
	RECIPIENT: 3,
	CONFIRM: 4,
} as const

export const isTransferStep = (value: unknown) =>
	Object.values(TRANSFER_STEPS).some((step) => step === value)

export const useTransferStore = defineStore(
	"transferStore",
	() => {
		const onTransferStep = ref(TRANSFER_STEPS.EVENT)
		const eventSelected = ref()
		const itemsSelected = ref([])
		const transferToFirstname = ref("")
		const transferToLastname = ref("")
		const transferToPhone = ref("")
		const transferToEmail = ref("")
		const transferredItems = ref([])

		const setOnStep = (value: number) => (onTransferStep.value = value)
		const setEventSelected = (value: any) => (eventSelected.value = value)
		const setItemsSelected = (value: any[]) => (itemsSelected.value = value)
		const addItemSelected = (value: any) => {
			const itemAlreadyAdded = itemsSelected.value.find((item: any) => item.id === value.id)
			if (!itemAlreadyAdded) {
				itemsSelected.value.push(value)
			}
		}

		const removeItemSelected = (value: any) => {
			const removeIndex = itemsSelected.value.findIndex((item: any) => item.id === value.id)
			if (removeIndex >= 0) {
				itemsSelected.value.splice(removeIndex, 1)
			}
		}

		const isItemSelected = (value: any) => {
			const itemIndex = itemsSelected.value.find((item: any) => item.id === value.id)
			return !!itemIndex
		}

		const clearItemsSelected = () => {
			itemsSelected.value = []
		}

		const setTransferToFirstname = (value: string) => (transferToFirstname.value = value)
		const setTransferToLastname = (value: string) => (transferToLastname.value = value)
		const setTransferToPhone = (value: string) => (transferToPhone.value = value)
		const setTransferToEmail = (value: string) => (transferToEmail.value = value)

		const addTransferredItem = (value: any) => {
			const itemAlreadyAdded = transferredItems.value.find((item: any) => item.id === value.id)
			if (!itemAlreadyAdded) {
				transferredItems.value.push(value)
			}
		}

		const $reset = () => {
			onTransferStep.value = TRANSFER_STEPS.EVENT
			eventSelected.value = ""
			itemsSelected.value = []
			transferToFirstname.value = ""
			transferToLastname.value = ""
			transferToPhone.value = ""
			transferToEmail.value = ""
			transferredItems.value = []
		}

		return {
			onTransferStep: onTransferStep,
			setOnStep,
			eventSelected,
			setEventSelected,
			itemsSelected,
			setItemsSelected,
			addItemSelected,
			removeItemSelected,
			isItemSelected,
			clearItemsSelected,
			transferToFirstname,
			setTransferToFirstname,
			transferToLastname,
			setTransferToLastname,
			transferToPhone,
			setTransferToPhone,
			transferToEmail,
			setTransferToEmail,
			transferredItems,
			addTransferredItem,
			$reset,
		}
	},
	{
		persist: {
			key: "up_transferStore", // Make sure this key is unique
			storage: localStorage, // or cookies if you're using cookie storage
		},
	},
)
